export default {
  install: (Vue, options) => {
    Vue.prototype.$debug = {
      show: function (msg, data) {
        console.log(msg)
        data.forEach(d => {
          console.log(d)
        })
      },
    }
  },
}
